import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-footer" }
const _hoisted_2 = { class: "page-footer__container d-flex" }
const _hoisted_3 = { class: "page-footer__left d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "page-footer__branding" }
const _hoisted_5 = { class: "page-footer__logo-subtitle" }
const _hoisted_6 = { class: "page-footer__social-media d-flex align-items-center d-lg-none" }
const _hoisted_7 = {
  target: "_blank",
  href: "https://www.facebook.com/DistyB2B"
}
const _hoisted_8 = {
  target: "_blank",
  href: "https://www.instagram.com/disty.b2b"
}
const _hoisted_9 = {
  target: "_blank",
  href: "https://www.linkedin.com/company/distyb2b"
}
const _hoisted_10 = { class: "page-footer__center d-flex flex-column justify-content-between" }
const _hoisted_11 = { class: "page-footer__about-us" }
const _hoisted_12 = { class: "page-footer__about-us-title" }
const _hoisted_13 = { class: "page-footer__about-us-content" }
const _hoisted_14 = { class: "page-footer__links d-flex align-items-center justify-content-between d-lg-none" }
const _hoisted_15 = { class: "page-footer__copywrite" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "page-footer__separator" }, "∙", -1)
const _hoisted_17 = { class: "page-footer__right d-flex flex-column align-items-center" }
const _hoisted_18 = { class: "page-footer__download-app-title" }
const _hoisted_19 = { class: "page-footer__download-app-subtitle" }
const _hoisted_20 = { class: "page-footer__app-links d-flex justify-content-center" }
const _hoisted_21 = {
  href: "#",
  class: "page-footer__qr-code d-none"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "page-footer__stores d-flex flex-column align-items-center" }
const _hoisted_24 = {
  href: "https://apps.apple.com/sa/app/disty-%D8%AF%D8%B3%D8%AA%D9%8A/id6737064072?l",
  target: "_blank"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  href: "https://play.google.com/store/apps/details?id=com.disty.store",
  target: "_blank"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "page-footer__mobile-only d-none d-lg-flex flex-column" }
const _hoisted_29 = { class: "page-footer__social-media d-flex align-items-center" }
const _hoisted_30 = {
  target: "_blank",
  href: "https://www.facebook.com/DistyB2B"
}
const _hoisted_31 = {
  target: "_blank",
  href: "https://www.instagram.com/disty.b2b"
}
const _hoisted_32 = {
  target: "_blank",
  href: "https://www.linkedin.com/company/distyb2b"
}
const _hoisted_33 = { class: "page-footer__links d-flex align-items-center" }
const _hoisted_34 = { class: "page-footer__copywrite" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "page-footer__separator" }, "∙", -1)

import Logo from '@/components/_shared/Logo/Logo.vue';
import Icon from '@/components/_shared/Icon/Icon.vue';
import useLocale from '@/util/locale';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageFooter',
  setup(__props) {

const { selectedLocaleId } = useLocale();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Logo, { place: "footer" }),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('footer.logoSubtitle')), 1)
        ]),
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_7, [
              _createVNode(Icon, { icon: "facebook" })
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_8, [
              _createVNode(Icon, { icon: "instagram" })
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_9, [
              _createVNode(Icon, { icon: "linkedin" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('footer.aboutUsTitle')), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('footer.aboutUsContent')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('footer.copywrite', [new Date().getFullYear()])), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: `/${_unref(selectedLocaleId)}/terms`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('footer.termsAndConditions')), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_16,
            _createVNode(_component_router_link, {
              to: `/${_unref(selectedLocaleId)}/privacy`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('footer.privacyPolicy')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('footer.downloadOurApp')), 1),
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('footer.downloadOurAppSubtitle')), 1),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("a", _hoisted_21, [
            _createElementVNode("img", {
              src: require(`@/assets/img/qr-code-footer.png`)
            }, null, 8, _hoisted_22)
          ]),
          _createElementVNode("span", _hoisted_23, [
            _createElementVNode("a", _hoisted_24, [
              _createElementVNode("img", {
                src: require(`@/assets/img/apple-store-gray.png`)
              }, null, 8, _hoisted_25)
            ]),
            _createElementVNode("a", _hoisted_26, [
              _createElementVNode("img", {
                src: require(`@/assets/img/google-play-gray.png`)
              }, null, 8, _hoisted_27)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("ul", _hoisted_29, [
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_30, [
              _createVNode(Icon, { icon: "facebook" })
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_31, [
              _createVNode(Icon, { icon: "instagram" })
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_32, [
              _createVNode(Icon, { icon: "linkedin" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('footer.copywrite', [new Date().getFullYear()])), 1),
          _createVNode(_component_router_link, {
            to: `/${_unref(selectedLocaleId)}/terms`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('footer.termsAndConditions')), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_35,
          _createVNode(_component_router_link, {
            to: `/${_unref(selectedLocaleId)}/privacy`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('footer.privacyPolicy')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}
}

})